import React from 'react';

import { usePopover } from './usePopover';
import { PopoverOptions } from './types';

import { PopoverContext } from './PopoverContext';

const WpPopover = ({ children, ...options }: { children: React.ReactNode } & PopoverOptions) => {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const tooltip = usePopover(options);
  return <PopoverContext.Provider value={tooltip}>{children}</PopoverContext.Provider>;
};

export default WpPopover;
